import axiosInstance from "../axiosInstance";

export const commonApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/common${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/common${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getSettings = async () => commonApi.get("/GetSettings");

// export const getAdditionalInstitutes = async (params) =>
//   applicationsApi.post("/GetAdditionalInstitutes", JSON.stringify(params), {
//     "Content-Type": "application/json",
//   });
